import { React } from 'libs/react';
import './Select.scss';
/**
 * @component Select
 * @since 1.0.0
 * @hidden
 */
export function Select(props) {
    let { name, ident, value, options, required, disabled, placeholder } = Object.assign({ placeholder: '' }, props);
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        if (props.onBlur) {
            props.onBlur();
        }
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        if (props.onFocus) {
            props.onFocus();
        }
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(e) {
        if (props.onChange) {
            props.onChange(e.currentTarget.value);
        }
    }
    if (placeholder) {
        options = options.slice(0);
        options.unshift({
            label: placeholder,
            value: ''
        });
    }
    return (React.createElement("select", { id: ident, name: name, value: value, required: required, disabled: disabled, onBlur: onBlur, onFocus: onFocus, onChange: onChange }, options.map((option) => (React.createElement("option", { key: option.value, value: option.value, disabled: option.locked },
        option.icon,
        option.label)))));
}
